import {
    getFacingDirection,
    deleteFacingDirection,
    createFacingDirection,
    updateFacingDirection
} from '../../../services/FacingDirectionService';
import {
    CONFIRMED_GET_FACING_DIRECTION
} from './FacingDirectionTypes';

export function getFacingDirectionAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
            dispatch({ type: 'FACING_DIRECTION_LOADING' });
            getFacingDirection(currentPage, pageSize, searchTerm, filterQuery)
                .then((response) => {
                    dispatch(confirmedGetFacingDirectionAction(response.data.data));
                })
                .catch(() => {
                    dispatch(confirmedGetFacingDirectionAction({ rows: [], count: 0, pages: 1 }));
                });
    };
}

export function confirmedGetFacingDirectionAction(data) {
    return {
        type: CONFIRMED_GET_FACING_DIRECTION,
        payload: data,
    };
}

export function deleteFacingDirectionAction(id, history) {
    return (dispatch, getState) => {
        return deleteFacingDirection(id).then((response) => {
            return response;
        });
    };
}

export function createFacingDirectionAction(data) {
    return () => {
        return createFacingDirection(data).then((response) => {
            return response;
        });
    };
}

export function updateFacingDirectionAction(id, data) {
    return () => {
        return updateFacingDirection(id, data).then((response) => {
            return response;
        });
    };
}

